import {Toast} from "primereact/toast";
import React, {useEffect, useRef, useState} from "react";
import {UseLoader} from "../../../hooks/useLoader";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import NumberFormat from "react-number-format";
import {error} from "../../../shared/utils/utils";
import {AutoComplete} from "primereact/autocomplete";
import {getAsociados} from "../../../api/liquidacionDeduccion.service";
import {useForm} from "react-hook-form";
import {guardarData} from "../../../api/pensionado.service";
import {confirmDialog} from "primereact/confirmdialog";


export const ModalNuevoPensionado= ({show, hide}) => {

    const [handleLoader] = UseLoader();

    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [clientes, setClientes] = useState([]);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const initParams = {
        porcenPrestaciones: 0,
    }

    const [field, setField] = useState(initParams);

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

    const toast = useRef(null);

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const onSubmit= async payload => {
        try {
            const datos = {
                asociado_id: selectedcliente.id,
                porcentaje: field.porcenPrestaciones,
                estado: payload.estado
            }
            //console.log(datos)
            if (datos.asociado_id){
                confirmDialog({
                    message: '¿Estas seguro?',
                    header: 'Confirmación',
                    acceptLabel: "Si",
                    rejectLabel: "No",
                    accept: async () =>  {
                        handleLoader(true);
                        const response= await guardarData(datos);
                        const data= await response.data;
                        //console.log(data)

                        handleLoader(false);
                        if (data.estado !== 200) {
                            toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                            return;
                        }

                        toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                        hide();
                    }
                });
            }
        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }



    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo pensionado" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información Pensionado
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="asociado"
                                    >
                                        Asociado *
                                    </label>
                                    <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                                  style={{"width": "100%"}}
                                                  completeMethod={searchCliente}
                                                  placeholder="Buscador de asociados"
                                                  size="30"
                                                  field="nombre" dropdown itemTemplate={itemTemplate}
                                                  onChange={(e) => setSelectedcliente(e.value)}/>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="pres"
                                    >
                                        Procentaje de prestaciones
                                    </label>
                                    <NumberFormat
                                        id="pres"
                                        thousandsGroupStyle="thousand"
                                        value={field.porcenPrestaciones}
                                        suffix="%"
                                        displayType="input"
                                        type="text"
                                        decimalSeparator="."
                                        className="form-input"
                                        thousandSeparator={false}
                                        allowNegative={false}
                                        onValueChange={(e) => setField({...register, porcenPrestaciones: e.value})}
                                    />
                                    {error(field.porcenPrestaciones, 'required')}
                                    {error(field.porcenPrestaciones, 'maxLength', 11)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado *
                                    </label>
                                    <select
                                        className="form-input"
                                        required
                                        {...register("estado", {required: true })}
                                        id="estado">
                                        <option value="">Seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>
                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
